/**
 * Auth Actions
 *
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 15.04.2016.
 */

import Cookies from 'js-cookie';
import axios from 'axios';
import _get from 'lodash/get';

import {GetPurchases, GetSubscriptions} from '../../purchase/actions-purchase';
import {LocaleChange} from '../../common/actions-common';

export const NAR_LOG_IN = 'log-in-with-user-password';
export const NAR_ME = 'fetch-me-data-nar';
export const CHANGE_PASSWORD = 'change-password-nar';
export const CHANGE_LANGUAGE = 'change-language-nar';

export function LogIn(username, password) {

  return (dispatch) => {
    let Q;

    Q = lh.common.request.post('/nar/v1/login', {
      password,
      msisdn: username,
    })
      .then(function (response) {
        return lh.system.auth({clientId: Config.client_id, deviceId: Config.device_id}, {ssoKey: response.data, ssoSystem: 'nar'});
      })
      .then(() => {

        let user = {
          user: username,
          token: lh.common.config.get('authToken')
        };

        Cookies.set('v2_' + Config.operator_ext_id, user, {expires: 7, path: '/'});

        dispatch(Me());

        return user;
      })
      .then((user) => {

        return Promise.all([GetPurchases().payload, GetSubscriptions().payload])
          .then(() => {

            return user;
          })
      });

    dispatch({
      type: NAR_LOG_IN,
      payload: Q
    });
  };
}

export function ChangePasssword(currentPsw, newPsw) {

  let Q;

  Q = axios.post(`api/nar/v1/users/me/commands/change-password`,
    {
      current_password: currentPsw,
      new_password: newPsw,
    },
    {
      headers: {'X-Auth-Token': lh.common.config.get('authToken')},
    });

  return {
    type: CHANGE_PASSWORD,
    payload: Q
  };
}

export function NarLocaleChange(locale) {

  return (dispatch) => {
    let Q;

    dispatch(LocaleChange(locale));

    Q = axios.patch(`api/nar/v1/users/me`,
        {
          language: locale.replace('_NAR', '').toUpperCase(),
        },
        {
          headers: {'X-Auth-Token': lh.common.config.get('authToken')},
        }
      );

    dispatch({
      type: CHANGE_LANGUAGE,
      payload: Q
    });
  };
}

export function Me() {
  return (dispatch) => {

    let Q;

    Q = axios(`api/nar/v1/users/me`,  {
      headers: {'X-Auth-Token': lh.common.config.get('authToken')},
    })
      .then((response) => {
        const locale = _get(response, 'data.data.language', 'EN').toLowerCase() + '_NAR';

        dispatch(LocaleChange(locale));
      });

    dispatch({
      type: NAR_ME,
      payload: Q
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/_extentions/nar/actions-nar.js